var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMoney(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 68.078,
    height: 45.155,
    viewBox: "0 0 68.078 45.155",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_money",
    transform: "translate(-176 -311)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_472",
    "data-name": "Subtraction 472",
    d: "M37.943,24.565H7.444A13.6,13.6,0,0,0,0,16.755V7.89A13.4,13.4,0,0,0,7.423,0h39A13.605,13.605,0,0,0,53.888,7.88v7.827a19.717,19.717,0,0,0-2.974-.224c-7.169,0-13,3.813-13,8.5a5.679,5.679,0,0,0,.03.581ZM26.913,6.482a6,6,0,1,0,6,6A6.007,6.007,0,0,0,26.913,6.482Z",
    transform: "translate(181.087 315.518)",
    fill: "#c8d1ec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_476",
    "data-name": "Subtraction 476",
    d: "M46.087,34H44V31.774A8.86,8.86,0,0,0,46.085,34ZM43,34H2a2,2,0,0,1-2-2V2A2,2,0,0,1,2,0H61a2,2,0,0,1,2,2V21.337a16.812,16.812,0,0,0-3.088-.945V11.777A13.513,13.513,0,0,1,52.186,3.6H11.86a13.516,13.516,0,0,1-7.729,8.176V21.934a13.516,13.516,0,0,1,7.729,8.171H43V34Z",
    transform: "translate(176 311)",
    fill: "#c8d1ec"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1756",
    "data-name": "Ellipse 1756",
    cx: 5,
    cy: 5,
    r: 5,
    transform: "translate(203 323)",
    fill: "#c8d1ec"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_12797",
    "data-name": "Group 12797",
    transform: "translate(218.756 332)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1790",
    "data-name": "Ellipse 1790",
    cx: 12,
    cy: 7.5,
    rx: 12,
    ry: 7.5,
    transform: "translate(1.244 0)",
    fill: "#c8d1ec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_474",
    "data-name": "Subtraction 474",
    d: "M-205.725-311.844a18.713,18.713,0,0,1-8.517-1.849c-2.287-1.2-3.546-2.814-3.546-4.541,0-.072,0-.182-.009-.321a12.237,12.237,0,0,1,.024-1.7c2.02,3.189,6.736,5.25,12.017,5.25,5.313,0,10.041-2.079,12.044-5.3.034.643.034,1.589.034,1.993v.038c0,1.73-1.256,3.348-3.538,4.557A18.561,18.561,0,0,1-205.725-311.844Z",
    transform: "translate(219 331)",
    fill: "#c8d1ec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_475",
    "data-name": "Subtraction 475",
    d: "M-205.772-311.846a17.78,17.78,0,0,1-8.485-1.907c-2.267-1.265-3.515-3.046-3.515-5.013,0-.111,0-.226-.009-.348a5.149,5.149,0,0,1,.045-1.115c2.106,2.673,6.79,4.4,11.936,4.4,5.126,0,9.86-1.738,12.059-4.429.027.3.023.676.019,1.043,0,.123,0,.243,0,.355,0,1.972-1.257,3.769-3.538,5.06A17.616,17.616,0,0,1-205.772-311.846Z",
    transform: "translate(219 336)",
    fill: "#c8d1ec"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoney);
export default __webpack_public_path__ + "static/media/money.1dce6320bf8ea49ac2256794acd6bb16.svg";
export { ForwardRef as ReactComponent };